module.exports = __webpack_public_path__ + "static/media/Menu-7.61e11651.jpg";